import React from 'react'

const TopBanner = ({masterConfigKey}) => {
  return (
    <>
   { masterConfigKey&& <div>
        {/* Desktop Banner: visible on md and up */}
        <img
            src={masterConfigKey?.desktopBannerUrl}
          alt="sponsor"
          className="hidden md:block w-full h-full "
        />
  
        {/* Mobile Banner: visible below md */}
        <img
          src={masterConfigKey?.mobileBannerUrl}
          alt="sponsor"
          className="block md:hidden w-full h-full"
        />
      </div>}
    </>
    
  )
}

export default TopBanner